var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C11.7688 32.1114 7.55606 31.4031 3.594 29.914C3.41718 29.8354 3.26695 29.7073 3.16151 29.5451C3.05608 29.3828 2.99998 29.1935 3 29C3.00291 26.3487 4.05742 23.8069 5.93215 21.9321C7.80688 20.0574 10.3487 19.0029 13 19H19C21.6513 19.0029 24.1931 20.0574 26.0679 21.9321C27.9426 23.8069 28.9971 26.3487 29 29C29 29.1935 28.9439 29.3828 28.8385 29.5451C28.7331 29.7073 28.5828 29.8354 28.406 29.914C24.4439 31.4031 20.2312 32.1114 16 32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17C11.421 17 8 12.249 8 8C8 5.87827 8.84285 3.84344 10.3431 2.34315C11.8434 0.842855 13.8783 0 16 0C18.1217 0 20.1566 0.842855 21.6569 2.34315C23.1571 3.84344 24 5.87827 24 8C24 12.249 20.579 17 16 17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3168a494e6b35fecc6b973200b59232b.svg";
export { ForwardRef as ReactComponent };